import { Link } from 'react-router-dom';
import { ROUTES } from '../routes/routeConfig';
import './SiteFooter.css';

const footerSections = [
  {
    title: '财富学院',
    links: [
      { label: '学习路径', to: ROUTES.academy },
      { label: '精选文章', to: ROUTES.academyArticles },
      { label: '推荐书籍', to: ROUTES.academyBooks },
      { label: '名人观点', to: ROUTES.academy },
    ],
  },
  {
    title: '市场研究院',
    links: [
      { label: '加密市场', to: ROUTES.market },
      { label: '黄金研究', to: ROUTES.marketGold },
      { label: '美股观察', to: ROUTES.marketStock },
      { label: 'K线工具', to: ROUTES.marketToolsPatternMatch },
    ],
  },
  {
    title: '社区与账号',
    links: [
      { label: '关于 GHOST', to: ROUTES.home },
      { label: '社群交流', to: ROUTES.community },
      { label: '登录账号', to: ROUTES.login },
      { label: '注册账号', to: ROUTES.register },
    ],
  },
];

export default function SiteFooter({ className = '', variant = 'default' }) {
  const classes = ['site-footer', `site-footer-${variant}`, className].filter(Boolean).join(' ');

  return (
    <footer className={classes}>
      <div className="site-footer-brand">
        <Link className="site-footer-logo" to={ROUTES.home}>GHOST</Link>
        <p>面向加密、黄金与美股市场的研究型交易社区。</p>
        <div className="site-footer-meta">
          <Link to={ROUTES.academy}>财富学院</Link>
          <Link to={ROUTES.market}>市场研究院</Link>
          <Link to={ROUTES.community}>社群交流</Link>
        </div>
      </div>

      <div className="site-footer-sections">
        {footerSections.map((section) => (
          <nav key={section.title} aria-label={section.title}>
            <strong>{section.title}</strong>
            {section.links.map((link) => (
              <Link key={`${section.title}-${link.label}`} to={link.to}>
                {link.label}
              </Link>
            ))}
          </nav>
        ))}
      </div>

      <div className="site-footer-bottom">
        <span>© 2026 GHOST. All rights reserved.</span>
        <span>社群交流请关注底部公众号</span>
      </div>
    </footer>
  );
}
